<template>
    <div>
        <v-row class="mt-1">
            <v-col cols="12" sm="6" md="6">
                <v-row no-gutters>
                    <v-col cols="5" sm="5" md="5">
                        <v-text-field 
                            v-model.lazy="dataRevenueT12Months" 
                            label="Trailing 12 Month Revenue"
                            prepend-inner-icon="mdi-currency-usd">
                        </v-text-field>
                    </v-col>
                    <v-col cols="1" sm="1" md="1">
                        &nbsp;
                    </v-col>
                    <v-col cols="6" sm="6" md="6">
                        <v-menu
                            v-model="dateMenu"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="editData.revenue_t12_asof_date"
                                    label="As of"
                                    append-icon="mdi-calendar"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on">
                                </v-text-field>
                            </template>
                            <v-date-picker
                                v-model="editData.revenue_t12_asof_date"
                                @input="dateMenu = false">
                            </v-date-picker>
                        </v-menu>
                    </v-col>
                </v-row>
            </v-col>
            <v-col cols="12" sm="6" md="6">
                <v-row no-gutters>
                    <v-col cols="5" sm="5" md="5">
                        <v-text-field 
                            v-model="editData.revenue_percent_recurring" 
                            label="Percent Recurring"
                            append-icon="mdi-percent">
                        </v-text-field>
                    </v-col>
                    <v-col cols="1" sm="1" md="1">
                        &nbsp;
                    </v-col>
                    <v-col cols="6" sm="6" md="6">
                        <v-text-field 
                            v-model.lazy="dataRevenueProjected" 
                            label="Projected Revenue"
                            prepend-inner-icon="mdi-currency-usd">
                        </v-text-field>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" sm="6" md="6">
                <h3 class="info--text">Recurring</h3>    
                <v-row>
                    <v-col cols="12">
                        <v-text-field 
                            v-model.lazy="dataRevenueFeesRecurring" 
                            label="Fees"
                            prepend-inner-icon="mdi-currency-usd">
                        </v-text-field>
                    </v-col>
                </v-row>                
                <v-row>
                    <v-col cols="12">
                        <v-text-field 
                            v-model.lazy="dataRevenueTrailsRecurring" 
                            label="Trails"
                            prepend-inner-icon="mdi-currency-usd">
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-text-field 
                            v-model.lazy="dataRevenue12b1sRecurring" 
                            label="12B-1s"
                            prepend-inner-icon="mdi-currency-usd">
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-text-field 
                            v-model.lazy="dataRevenueHourlyRecurring" 
                            label="Hourly"
                            prepend-inner-icon="mdi-currency-usd">
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-text-field 
                            v-model.lazy="dataRevenueFinancialPlanningRecurring" 
                            label="Financial Planning Fees"
                            prepend-inner-icon="mdi-currency-usd">
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-text-field 
                            v-model.lazy="dataRevenueOtherRecurring" 
                            label="Other"
                            prepend-inner-icon="mdi-currency-usd">
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-text-field 
                            v-model.lazy="dataRevenueOsjRecurring" 
                            label="OSJ/Overrides"
                            prepend-inner-icon="mdi-currency-usd">
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-text-field 
                            v-model.lazy="dataRevenueAccountingRecurring" 
                            label="Accounting/Taxes"
                            prepend-inner-icon="mdi-currency-usd">
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-text-field 
                            v-model.lazy="dataRevenueDirectInsuranceRecurring" 
                            label="Direct Insurance"
                            prepend-inner-icon="mdi-currency-usd">
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-text-field 
                            v-model.lazy="dataRevenueGroupHealthInsuranceRecurring" 
                            label="Group Health Insurance"
                            prepend-inner-icon="mdi-currency-usd">
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-text-field 
                            v-model.lazy="dataRevenueMedicareRecurring" 
                            label="Medicare"
                            prepend-inner-icon="mdi-currency-usd">
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-text-field 
                            v-model.lazy="dataRevenueRenewalsRecurring" 
                            label="Renewals (Insurance)"
                            prepend-inner-icon="mdi-currency-usd">
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-text-field 
                            v-model.lazy="dataRevenueRetirementPlansRecurring" 
                            label="Retirement Plans"
                            prepend-inner-icon="mdi-currency-usd">
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-text-field 
                            v-model.lazy="dataRevenueCompilations" 
                            label="Compilations"
                            prepend-inner-icon="mdi-currency-usd">
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" style="padding:47px 0"></v-col>
                </v-row>
            </v-col>
             <v-col cols="12" sm="6" md="6">
                <h3 class="info--text">Transactional</h3>
                <v-row>
                    <v-col cols="12" style="padding:47px 0"></v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-text-field 
                            v-model.lazy="dataRevenueTrailsTransactional" 
                            label="Trails (VA Commissions)"
                            prepend-inner-icon="mdi-currency-usd">
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-text-field 
                            v-model.lazy="dataRevenue12b1sTransactional" 
                            label="12B-1s (MA Commissions)"
                            prepend-inner-icon="mdi-currency-usd">
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-text-field 
                            v-model.lazy="dataRevenueHourlyTransactional" 
                            label="Hourly"
                            prepend-inner-icon="mdi-currency-usd"
                            @change="calculateTransactionalTotal">
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-text-field 
                            v-model.lazy="dataRevenueFinancialPlanningTransactional" 
                            label="Financial Planning Fees"
                            prepend-inner-icon="mdi-currency-usd"
                            @change="calculateTransactionalTotal">
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-text-field 
                            v-model.lazy="dataRevenueOtherTransactional" 
                            label="Other"
                            prepend-inner-icon="mdi-currency-usd"
                            @change="calculateTransactionalTotal">
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-text-field 
                            v-model.lazy="dataRevenueOsjTransactional" 
                            label="OSJ/Overrides"
                            prepend-inner-icon="mdi-currency-usd"
                            @change="calculateTransactionalTotal">
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-text-field 
                            v-model.lazy="dataRevenueAccountingTransactional" 
                            label="Accounting/Taxes"
                            prepend-inner-icon="mdi-currency-usd"
                            @change="calculateTransactionalTotal">
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-text-field 
                            v-model.lazy="dataRevenueDirectInsuranceTransactional" 
                            label="Direct Insurance"
                            prepend-inner-icon="mdi-currency-usd"
                            @change="calculateTransactionalTotal">
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-text-field 
                            v-model.lazy="dataRevenueGroupHealthInsuranceTransactional" 
                            label="Group Health Insurance"
                            prepend-inner-icon="mdi-currency-usd">
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-text-field 
                            v-model.lazy="dataRevenueMedicareTransactional" 
                            label="Medicare"
                            prepend-inner-icon="mdi-currency-usd">
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-text-field 
                            v-model.lazy="dataRevenueInsuranceCommissionsTransactional" 
                            label="Insurance Commissions"
                            prepend-inner-icon="mdi-currency-usd"
                            @change="calculateTransactionalTotal">
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-text-field 
                            v-model.lazy="dataRevenueSecuritiesCommissionsTransactional" 
                            label="Securities Commissions"
                            prepend-inner-icon="mdi-currency-usd"
                            @change="calculateTransactionalTotal">
                        </v-text-field>
                    </v-col>
                </v-row>
                
                <v-row>
                    <v-col cols="12">
                        <v-text-field 
                            v-model.lazy="dataRevenueMutualFundCommissionsTransactional" 
                            label="Mutual Fund Commissions"
                            prepend-inner-icon="mdi-currency-usd"
                            @change="calculateTransactionalTotal">
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-text-field 
                            v-model.lazy="dataRevenueStockCommissionsTransactional" 
                            label="Stock Commissions"
                            prepend-inner-icon="mdi-currency-usd"
                            @change="calculateTransactionalTotal">
                        </v-text-field>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="12">
                        <div style="margin:1.5rem auto; border-top: .12rem dotted #002244"></div>
                        <v-text-field 
                            v-model="dataRevenueTotalsTransactional" 
                            label="Transactional Totals"
                            prepend-inner-icon="mdi-currency-usd"
                            disabled
                            persistent-hint
                            hint="Calculation of all transactional fields above">
                        </v-text-field>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </div>
</template>


<script>
    import { 
        formatNumbers,
        scrubNumbers } from '../../helpers/utilities'

    export default {
        name: 'RevenueBreakdown',
        props: [
            'editData',
            'calcExpensesPercentageRevenue'
        ],

        data: () => ({
            dateMenu: false
        }),

        watch: {
            dataRevenueT12Months () {
                this.$emit('calcExpensesPercentageRevenue', { 'expenses_total_overhead': this.editData.expenses_total_overhead, 'revenue_t12_months': this.editData.revenue_t12_months } )
            }
        },
        
        computed: {
            dataRevenueT12Months: {
                get: function() {
                    return this.editData.revenue_t12_months != null ? formatNumbers(scrubNumbers(this.editData.revenue_t12_months)) : 0
                },
                set: function(val) {
                    this.swapNumbers('revenue_t12_months', val);
                    return val;
                }
            },
            dataRevenueProjected: {
                get: function() {
                    return this.editData.revenue_projected != null ? formatNumbers(scrubNumbers(this.editData.revenue_projected)) : ''
                },
                set: function(val) {
                    this.swapNumbers('revenue_projected', val);
                    return val;
                }
            },
            dataRevenueFeesRecurring: {
                get: function() {
                    return this.editData.revenue_fees_recurring != null ? formatNumbers(scrubNumbers(this.editData.revenue_fees_recurring)) : ''
                },
                set: function(val) {
                    this.swapNumbers('revenue_fees_recurring', val);
                    return val;
                }
            },
            dataRevenueTrailsRecurring: {
                get: function() {
                    return this.editData.revenue_trails_recurring != null ? formatNumbers(scrubNumbers(this.editData.revenue_trails_recurring)) : ''           
                },
                set: function(val) {
                    this.swapNumbers('revenue_trails_recurring', val);
                    return val
                }
            },
            dataRevenue12b1sRecurring: {
                get: function() {
                    return this.editData.revenue_12b1s_recurring != null ? formatNumbers(scrubNumbers(this.editData.revenue_12b1s_recurring)) : ''
                },
                set: function(val) {
                    this.swapNumbers('revenue_12b1s_recurring', val);
                    return val;
                }
            },
            dataRevenueRenewalsRecurring: {
                get: function() {
                    return this.editData.revenue_renewals_recurring != null ? formatNumbers(scrubNumbers(this.editData.revenue_renewals_recurring)) : ''           
                },
                set: function(val) {
                    this.swapNumbers('revenue_renewals_recurring', val);
                    return val
                }
            },
            dataRevenueHourlyRecurring: {
                get: function() {
                    return this.editData.revenue_hourly_recurring != null ? formatNumbers(scrubNumbers(this.editData.revenue_hourly_recurring)) : ''
                },
                set: function(val) {
                    this.swapNumbers('revenue_hourly_recurring', val);
                    return val;
                }
            },
            dataRevenueFinancialPlanningRecurring: {
                get: function() {
                    return this.editData.revenue_financial_planning_recurring != null ? formatNumbers(scrubNumbers(this.editData.revenue_financial_planning_recurring)) : ''           
                },
                set: function(val) {
                    this.swapNumbers('revenue_financial_planning_recurring', val);
                    return val
                }
            },
            dataRevenueOtherRecurring: {
                get: function() {
                    return this.editData.revenue_other_recurring != null ? formatNumbers(scrubNumbers(this.editData.revenue_other_recurring)) : ''
                },
                set: function(val) {
                    this.swapNumbers('revenue_other_recurring', val);
                    return val;
                }
            },
            dataRevenueOsjRecurring: {
                get: function() {
                    return this.editData.revenue_osj_recurring != null ? formatNumbers(scrubNumbers(this.editData.revenue_osj_recurring)) : ''           
                },
                set: function(val) {
                    this.swapNumbers('revenue_osj_recurring', val);
                    return val
                }
            },
            dataRevenueAccountingRecurring: {
                get: function() {
                    return this.editData.revenue_accounting_recurring != null ? formatNumbers(scrubNumbers(this.editData.revenue_accounting_recurring)) : ''
                },
                set: function(val) {
                    this.swapNumbers('revenue_accounting_recurring', val);
                    return val;
                }
            },
            dataRevenueDirectInsuranceRecurring: {
                get: function() {
                    return this.editData.revenue_direct_insurance_recurring != null ? formatNumbers(scrubNumbers(this.editData.revenue_direct_insurance_recurring)) : ''           
                },
                set: function(val) {
                    this.swapNumbers('revenue_direct_insurance_recurring', val);
                    return val
                }
            },
            dataRevenueGroupHealthInsuranceRecurring: {
                get: function() {
                    return this.editData.revenue_group_health_insurance_recurring != null ? formatNumbers(scrubNumbers(this.editData.revenue_group_health_insurance_recurring)) : ''           
                },
                set: function(val) {
                    this.swapNumbers('revenue_group_health_insurance_recurring', val);
                    return val
                }
            },
            dataRevenueMedicareRecurring: {
                get: function() {
                    return this.editData.revenue_medicare_recurring != null ? formatNumbers(scrubNumbers(this.editData.revenue_medicare_recurring)) : ''           
                },
                set: function(val) {
                    this.swapNumbers('revenue_medicare_recurring', val);
                    return val
                }
            },
            dataRevenueRetirementPlansRecurring: {
                get: function() {
                    return this.editData.revenue_retirement_plans_recurring != null ? formatNumbers(scrubNumbers(this.editData.revenue_retirement_plans_recurring)) : ''           
                },
                set: function(val) {
                    this.swapNumbers('revenue_retirement_plans_recurring', val);
                    return val
                }
            },
            dataRevenueCompilations: {
                get: function() {
                    return this.editData.revenue_compilations != null ? formatNumbers(scrubNumbers(this.editData.revenue_compilations)) : ''           
                },
                set: function(val) {
                    this.swapNumbers('revenue_compilations', val);
                    return val
                }
            },
            dataRevenueTrailsTransactional: {
                get: function() {
                    return this.editData.revenue_trails_commissions_transactional != null ? formatNumbers(scrubNumbers(this.editData.revenue_trails_commissions_transactional)) : ''           
                },
                set: function(val) {
                    this.swapNumbers('revenue_trails_commissions_transactional', val);
                    return val
                }
            },
            dataRevenue12b1sTransactional: {
                get: function() {
                    return this.editData.revenue_12b1s_commissions_transactional != null ? formatNumbers(scrubNumbers(this.editData.revenue_12b1s_commissions_transactional)) : ''           
                },
                set: function(val) {
                    this.swapNumbers('revenue_12b1s_commissions_transactional', val);
                    return val
                }
            },
            dataRevenueHourlyTransactional: {
                get: function() {
                    return this.editData.revenue_hourly_transactional != null ? formatNumbers(scrubNumbers(this.editData.revenue_hourly_transactional)) : ''           
                },
                set: function(val) {
                    this.swapNumbers('revenue_hourly_transactional', val);
                    return val
                }
            },
            dataRevenueFinancialPlanningTransactional: {
                get: function() {
                    return this.editData.revenue_financial_planning_transactional != null ? formatNumbers(scrubNumbers(this.editData.revenue_financial_planning_transactional)) : ''
                },
                set: function(val) {
                    this.swapNumbers('revenue_financial_planning_transactional', val);
                    return val;
                }
            },
            dataRevenueOtherTransactional: {
                get: function() {
                    return this.editData.revenue_other_transactional != null ? formatNumbers(scrubNumbers(this.editData.revenue_other_transactional)) : ''           
                },
                set: function(val) {
                    this.swapNumbers('revenue_other_transactional', val);
                    return val
                }
            },
            dataRevenueOsjTransactional: {
                get: function() {
                    return this.editData.revenue_osj_transactional != null ? formatNumbers(scrubNumbers(this.editData.revenue_osj_transactional)) : ''
                },
                set: function(val) {
                    this.swapNumbers('revenue_osj_transactional', val);
                    return val;
                }
            },
            dataRevenueAccountingTransactional: {
                get: function() {
                    return this.editData.revenue_accounting_transactional != null ? formatNumbers(scrubNumbers(this.editData.revenue_accounting_transactional)) : ''           
                },
                set: function(val) {
                    this.swapNumbers('revenue_accounting_transactional', val);
                    return val
                }
            },
            dataRevenueDirectInsuranceTransactional: {
                get: function() {
                    return this.editData.revenue_direct_insurance_transactional != null ? formatNumbers(scrubNumbers(this.editData.revenue_direct_insurance_transactional)) : ''
                },
                set: function(val) {
                    this.swapNumbers('revenue_direct_insurance_transactional', val);
                    return val;
                }
            },
            dataRevenueGroupHealthInsuranceTransactional: {
                get: function() {
                    return this.editData.revenue_group_health_insurance_transactional != null ? formatNumbers(scrubNumbers(this.editData.revenue_group_health_insurance_transactional)) : ''           
                },
                set: function(val) {
                    this.swapNumbers('revenue_group_health_insurance_transactional', val);
                    return val
                }
            },
            dataRevenueMedicareTransactional: {
                get: function() {
                    return this.editData.revenue_medicare_transactional != null ? formatNumbers(scrubNumbers(this.editData.revenue_medicare_transactional)) : ''           
                },
                set: function(val) {
                    this.swapNumbers('revenue_medicare_transactional', val);
                    return val
                }
            },
            dataRevenueSecuritiesCommissionsTransactional: {
                get: function() {
                    return this.editData.revenue_securities_commissions_transactional != null ? formatNumbers(scrubNumbers(this.editData.revenue_securities_commissions_transactional)) : ''           
                },
                set: function(val) {
                    this.swapNumbers('revenue_securities_commissions_transactional', val);
                    return val
                }
            },
            dataRevenueInsuranceCommissionsTransactional: {
                get: function() {
                    return this.editData.revenue_insurance_commissions_transactional != null ? formatNumbers(scrubNumbers(this.editData.revenue_insurance_commissions_transactional)) : ''
                },
                set: function(val) {
                    this.swapNumbers('revenue_insurance_commissions_transactional', val);
                    return val;
                }
            },
            dataRevenueMutualFundCommissionsTransactional: {
                get: function() {
                    return this.editData.revenue_mutual_fund_commissions_transactional != null ? formatNumbers(scrubNumbers(this.editData.revenue_mutual_fund_commissions_transactional)) : ''           
                },
                set: function(val) {
                    this.swapNumbers('revenue_mutual_fund_commissions_transactional', val);
                    return val
                }
            },
            dataRevenueStockCommissionsTransactional: {
                get: function() {
                    return this.editData.revenue_stock_commissions_transactional != null ? formatNumbers(scrubNumbers(this.editData.revenue_stock_commissions_transactional)) : ''           
                },
                set: function(val) {
                    this.swapNumbers('revenue_stock_commissions_transactional', val);
                    return val
                }
            },
            dataRevenueTotalsTransactional: {
                get: function() {
                    return this.editData.revenue_totals_transactional != null ? formatNumbers(this.editData.revenue_totals_transactional) : ''           
                },
                set: function(val) {
                    this.calculateTransactionalTotal;
                }
            }
        },

        mounted () {},

        methods: {
            swapNumbers: function (field, val) {
                this.editData[field] = scrubNumbers(val);
            },

            calculateTransactionalTotal: function () {
                const calculated_val = Math.round( 
                    (parseInt(this.editData.revenue_hourly_transactional) || 0) + 
                    (parseInt(this.editData.revenue_financial_planning_transactional) || 0) + 
                    (parseInt(this.editData.revenue_other_transactional) || 0) + 
                    (parseInt(this.editData.revenue_osj_transactional) || 0) + 
                    (parseInt(this.editData.revenue_accounting_transactional) || 0) + 
                    (parseInt(this.editData.revenue_direct_insurance_transactional) || 0) + 
                    (parseInt(this.editData.revenue_group_health_insurance_transactional) || 0) +
                    (parseInt(this.editData.revenue_medicare_transactional) || 0) +
                    (parseInt(this.editData.revenue_securities_commissions_transactional) || 0) + 
                    (parseInt(this.editData.revenue_insurance_commissions_transactional) || 0) +
                    (parseInt(this.editData.revenue_trails_commissions_transactional) || 0) + 
                    (parseInt(this.editData.revenue_12b1s_commissions_transactional) || 0) + 
                    (parseInt(this.editData.revenue_mutual_fund_commissions_transactional) || 0) + 
                    (parseInt(this.editData.revenue_stock_commissions_transactional) || 0)
                );
                this.dataRevenueTotalsTransactional = formatNumbers(calculated_val);
                this.editData.revenue_totals_transactional = calculated_val;
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/prospectus-sections/RevenueBreakdown.vue